interface DividerProps {
  text?: string;
  className?: string;
}

export function Divider({ text, className = '' }: DividerProps) {
  if (text) {
    return (
      <div className={`flex items-center ${className}`}>
        <div className="flex-1 border-t border-border" />
        <span className="px-3 text-sm text-muted">{text}</span>
        <div className="flex-1 border-t border-border" />
      </div>
    );
  }

  return <div className={`border-t border-border ${className}`} />;
}
